import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubSection } from '../../pages/project-management/service-roadmaps/roadmap-interface';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { ToastService } from 'src/app/services/toast.service';
import { AppConstants } from 'src/app/utilities/constant';
import { ActivatedRoute } from '@angular/router';
interface RoadmapSection {
  title: string;
  content: string;
}
interface RoadmapSectionDetails {
  createdDate: string;
  id: string;
  sectionId: string;
  sectionName: string;
  SubSections?: SubSection[]
}
@Component({
  selector: 'app-section-list',
  templateUrl: './section-list.component.html',
  styleUrls: ['./section-list.component.scss'],
})
export class SectionListComponent implements OnInit {
  @Input() sections = [];
  public selectedSection: RoadmapSection;
  public selectedIndex: number = 0;
  @Input() addBtn: boolean;
  @Input() removeBtn: boolean;
  @Input() title: string;
  @Input() roadmapData: any;
  @Input() roadmapId: string;

  @Output() sectionSelected: EventEmitter<RoadmapSection> = new EventEmitter<RoadmapSection>();
  queryParams: any={};

  constructor(private backendService: BackendCallService,
    private toastService: ToastService,
    private route: ActivatedRoute) {
      this.route.queryParams.subscribe(async (params) => {
        this.queryParams=params;
      });
     }

  ngOnInit() {
    setTimeout(() => {
      console.log(this.sections, 'this.sections')
      if(this.sections) {
        this.selectedSection = this.sections[0];
        this.sectionSelected.emit(this.selectedSection);
      }else {
        this.sections = [];
      }
    }, 1000);
   }

  /**
   * Adds section
   */
  public addSection() {
    const newSection: RoadmapSectionDetails = {
      createdDate: '',
      id: '',
      sectionId: '',
      sectionName: '',
      SubSections: []
    };
    this.sections.push(newSection);
    this.selectSection(this.sections.length - 1);
    console.log(this.sections, 'added .sections')
  }

  /**
   * Deletes section
   * 
   * @param section section
   * @param index index
   * @param event event
   */
  public deleteSection(section, index: number, event: Event) {
    event.stopPropagation();
    this.selectedSection = null;
    this.selectedIndex = null;
    let sectionId: any;
    if(section.sectionId){
      this.sections.forEach((element, i) => {
        if (element.sectionId == section.sectionId) {
          sectionId = element.sectionId;
          this.sections.splice(index, 1);
        }
      });
      const payload = {
        id: this.roadmapId,
        serviceMachineId: this.queryParams.serviceMachineId,
        projectId: this.queryParams.project_id,
        section: [{
          sectionId: sectionId,
          isDelete: true,
          subSection: [{
            subSection_Id: '',
            isDelete: false,
            steps: [{
              id: '',
              isDelete: false
            }]
          }]
        }]
      };
      this.backendService.deleteRoadmapSectionsData(payload).subscribe(
        (data: any) => {
          this.toastService.presentToast(data, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
        },
        err => {
          this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
        }
      );
    }else {
      this.sections.splice(index, 1);
    }

  }

  /**
   * Selects section
   * 
   * @param index 
   */
  public selectSection(index: number) {
    this.selectedIndex = index;
    this.selectedSection = this.sections[index];
    console.log(this.selectedSection);
    this.sectionSelected.emit(this.selectedSection);
  }

  onSectionNameChanged(this){
    this.sectionSelected.emit(this);
  }
}
